import React from "react";

export const EventPPColumnFormatter = (cellContent, row, rowIndex, dIndexName) => (
  cellContent ? 'Public' :'Private'
  
);
